import { Autoplay, Controller, EffectFade, Navigation, Pagination, Scrollbar, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Scrollbar]) // Swiper宣言

if (document.querySelector('body.lp')) {
  document.querySelectorAll('.js-interview').forEach((interview) => {
    const swiper = new Swiper(interview, {
      loop: true,
      speed: 1000,
      slidesPerView: 1,
      // slidesPerGroup: 1.5,
      spaceBetween: 16,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      },
      navigation: {
        nextEl: interview.querySelector('.js-next'),
        prevEl: interview.querySelector('.js-prev'),
      },
      pagination: {
        el: interview.querySelector('.js-pagination'),
        clickable: true,
      },

      breakpoints: {
        769: {
          slidesPerView: 1.8,
        },
      },
    })
  })

  const fixNavClose = document.querySelector('.js-fixnav-close')
  if (fixNavClose) {
    fixNavClose.addEventListener('click', (e) => {
      const parent = e.target.closest('.lpFixNav')
      parent.classList.add('is_close')
    })
  }

  const adjustFixNav = () => {
    const scrollTop = document.documentElement.scrollTop
    const scrollBottom = scrollTop + document.documentElement.clientHeight
    const footerTop = document.querySelector('.lpFooter').getBoundingClientRect().top + scrollTop

    const fixNav = document.querySelector('.js-fixnav')

    if (fixNav) {
      if (footerTop < scrollBottom) {
        fixNav.classList.add('is_hide')
      } else {
        fixNav.classList.remove('is_hide')
      }
    }
  }

  document.addEventListener('scroll', adjustFixNav)
  document.addEventListener('resize', adjustFixNav)
  adjustFixNav()
}
